import Model from "./Model";

class ChatBot extends Model {
    getId() {
        return this.attrs.id;
    }
    
    setId(value) {
        this.attrs.id = value;
        return this;
    }

    getServiceId() {
        return this.attrs.serviceId;
    }
    
    setServiceId(value) {
        this.attrs.serviceId = value;
        return this;
    }

    getTemplateName() {
        return this.attrs.templateName;
    }
    
    setTemplateName(value) {
        this.attrs.templateName = value;
        return this;
    }
    
    getTemplate() {
        return this.attrs.template;
    }
    
    setTemplate(value) {
        this.attrs.template = value;
        return this;
    }
    getStatus() {
        return this.attrs.status;
      }
    
    setStatus(value) {
        this.attrs.status = value;
        return this;
    }

    getAction() {
        return this.attrs.action;
      }
    
    setAction(value) {
        this.attrs.action = value;
        return this;
    }

    getTrigger() {
        return this.attrs.trigger;
      }
    
    setTrigger(value) {
        this.attrs.trigger = value;
        return this;
    }

    getDescription() {
        return this.attrs.description;
      }
    
    setDescription(value) {
        this.attrs.description = value;
        return this;
    }
    getContacts() {
        return this.attrs.contacts;
      }
    
    setContacts(value) {
        this.attrs.contacts = value;
        return this;
    }

    getLastRun() {
        return this.attrs.lastRun;
      }
    
    setLastRun(value) {
        this.attrs.lastRun = value;
        return this;
    }
    getNextRun() {
        return this.attrs.nextRun;
      }
    
    setNextRun(value) {
        this.attrs.nextRun = value;
        return this;
    }

    getCreatedAt() {
        return this.attrs.createdAt;
      }
    
    setCreatedAt(value) {
        this.attrs.createdAt = value;
        return this;
    }

}
export default ChatBot;